'use strict';
import angular from 'angular';
import creativeLibraryHtml from '../views/directive_creativeLib.html';
import creativePreviewHtml from '../views/directive_creativePreview.html';

angular.module('creatives.directives', []);

angular.module('creatives.directives')

    .directive('creativeLibrary', ["creativesService", "ClusterService", '$ioAlert', 'ModalService', 'MediaService', 'Upload', '$rootScope', '$state', function(creativesService, ClusterService, $ioAlert, ModalService, MediaService, Upload, $rs, $state) {
        return {
            restrict: 'EA',
            templateUrl: creativeLibraryHtml,
            scope: {
                "selectedCreatives": "=",
                "thirdPartyCreatives":"=",
                "uploadMedia": "=",
                "addLibrary": "=",
                "clientId": "=",
                "fromPage": "=",
                "returnModal": "="
            },
            link: function(scope, element, attr) {
                scope.isSelected = false;
                scope.selectedCreatives = [];
                scope.thirdPartyCreatives = [];
                scope.value = 0;
                scope.addLibrary = false;
                scope.islibrary = false;
                scope.creatives = [];
                scope.isLoading = false;
                scope.noMedia = false;
                scope.page = 1;
                var currentPage;
                var creativeArr = [
                    'application/pdf',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // xlsx
                    'application/vnd.ms-excel',                                               // xls
                    'application/zip',                                                        // zip
                    'application/octet-stream',                                               // zip
                    'application/x-zip-compressed',                                           // zip
                    'multipart/x-zip',                                                        // zip
                    'image/png',
                    'image/jpeg',
                    'image/jpg',
                    'image/gif',
                    'video/mp4',
                    'video/ogg',
                    'audio/mpeg', // mp3
                    'text/csv',
                ];
                scope.showAddTolibrary = false;
                scope.showDisclaimerText = false;
                scope.indexArr = [];

                /*
                 *  Delete file
                 */
                scope.deleteFile = function(fileModal, index) {
                    fileModal = fileModal.splice(index, 1);
                }
                scope.delThirdPartySnippet = function(index) {
                    scope.thirdPartyCreatives.splice(index, 1);
                    scope.value =scope.thirdPartyCreatives.length;
                }


                scope.updateSelected = function(creative, isEdit) {
                    var index = scope.selectedCreatives.indexOf(creative);
                    if (index >= 0 && !isEdit) {
                        scope.selectedCreatives.splice(index, 1);
                        if (scope.selectedCreatives.length == 0) {
                            scope.isSelected = false;
                        } else {
                            scope.isSelected = true;
                        }
                    } else {
                        scope.isSelected = true;
                        scope.selectedCreatives.push(creative);
                    }
                };

                /*
                 *  For lineitems show helper text and option for user to upload to creative library
                 */
                scope.upload = function(image) {
                    scope.showAddTolibrary = false;
                    if (image && scope.fromPage == 'lineitems') {
                        for (var i = 0, len = image.length; i < len; i++) {
                            if (creativeArr.indexOf(image[i].type) > -1) {
                                scope.showAddTolibrary = true;
                            } else {
                                scope.showDisclaimerText = true;
                            }
                        }
                    }
                }

                scope.updateToLibrary = function(lib) {
                    scope.addLibrary = lib;
                }

                scope.validate = function(fileModal, index) {
                    var file_name = fileModal[index].name;
                    var validFilename = /^[A-Za-z0-9_.@()-\s]+\.[^.]+$/i.test(file_name);
                    if (!validFilename) {
                        console.log('Warning, filename contains metacharacters.');
                    }
                }

                /*
                 * Get Creatives based on clientId
                 */
                scope.getCreatives = function() {
                    if (scope.isLoading || currentPage == scope.page) {
                        return;
                    }
                    if (currentPage == 0) {
                        scope.creatives = [];
                    }
                    currentPage = scope.page;
                    scope.isLoading = true;
                    var params = {};
                    params = {
                        "clientId": scope.clientId,
                        "thumbWidth": 200,
                        "perPage": 10,
                        "page": scope.page

                    };
                    creativesService.getCreativesForClient(params).then(function(success) {
                        scope.creatives = scope.creatives.concat(success.creatives);
                        scope.isLoading = false;
                        if (success.creatives.length) {
                            scope.page = scope.page + 1;
                        }
                        if (scope.creatives.length) {
                            scope.noMedia = false;
                        } else {
                            scope.noMedia = true;
                        }
                        scope.isLoading = false;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Could not get Creatives.', 'error');
                    });

                };

               /* option for user to add third party creative */

                scope.addThirdPartyCreatives =function(count, shouldAddIntoExisting){
                    if(!shouldAddIntoExisting){
                        scope.thirdPartyCreatives = [];
                    }
                    for (var i = 0; i < count; i++) {
                        if (scope.thirdPartyCreatives.length < 10) {
                            scope.thirdPartyCreatives.push({
                                "name": "",
                                "snippet": "",
                                "id": ""
                            });
                        }
                    }
                    scope.value =scope.thirdPartyCreatives.length;
                }

                scope.addCreatives = function() {
                    if (scope.uploadMedia.images) {
                        $ioAlert.show('', 'Creatives are being uploaded dont refresh the page. You can check the status in the notifications tab', 'success');
                        angular.forEach(scope.uploadMedia.images, function(file) {
                            creativesService.getImgSignature({ clientId: scope.clientId, fileName: file.name }).then(function(success) {
                                var additionalParams = {
                                    "from": "client",
                                    "clientId": scope.clientId,
                                    "file_name": file.name,
                                    "file_size": file.size
                                }
                                //$state.go('ioclients');
                                $rs.$broadcast('cloudinaryImageUpload', success, file, additionalParams);
                            }, function(error) {
                                const details = JSON.stringify(error);
                                $ioAlert.show('Error!', 'Could not get img signature.' + details, 'error');
                                console.log(error);
                            });

                        });

                    } else {
                        $ioAlert.show("Error!", "Upload at least one file", 'error');
                    }
                }

                var init = function() {
                    if (scope.clientId) {

                    } else {
                        $ioAlert.show("Error!", "No client Selected Please select client and try again.", 'error');
                    }
                    if (scope.fromPage == 'clients') {
                        scope.accepType = "application/pdf, image/*, video/*"
                    } else {
                        if (scope.returnModal) {
                            if (typeof scope.returnModal == 'string') {
                                scope.returnModal = JSON.parse(scope.returnModal);
                            }
                            scope.uploadMedia.images = scope.returnModal.media;
                            scope.upload(scope.uploadMedia.images);
                            //scope.selectedCreatives = scope.returnModal.selectedImages;
                            if(scope.returnModal.thirdPartyCreatives){
                                scope.thirdPartyCreatives = scope.returnModal.thirdPartyCreatives;
                                scope.value =scope.thirdPartyCreatives.length;
                            }
                        }

                        scope.accepType = "";
                    }
                    creativesService.getAcceptableFileTypes('upload').then(function(response) {
                        if (response.fileTypes.length) {
                            var fileTypes = response.fileTypes;
                            var acceptTypes = "";
                            for (var i = 0, len = fileTypes.length; i < len; i++) {
                                if (fileTypes[i].name != "jpeg")
                                    acceptTypes += ",." + fileTypes[i].name;
                            }
                            acceptTypes = acceptTypes.substring(2);
                            scope.accepType = acceptTypes;
                            scope.pattenType = "'" + acceptTypes + "'";
                        }
                    }, function(error) {
                        $ioAlert.show('Error!', 'Could not get acceptable file types.', 'error');
                    });
                }
                init();
            }
        }
    }])
    .directive('creativePreview', function($modal) {
        return {
            restrict: 'EA',
            scope: {
                "creativeObj": "="
            },
            link: function(scope, element, attr) {
                element.click(function(eve) {
                    $modal.open({
                        animation: true,
                        templateUrl: creativePreviewHtml,
                        controller: function($scope, creative) {
                            $scope.creativeObj = creative;
                        },
                        resolve: {
                            creative: function() {
                                return scope.creativeObj;
                            }
                        }
                    });
                })
            }
        }
    });